import { memo, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import SoftButton from "components/SoftButton";
import FilterOptions from "./FilterOptions";

const FilterDialog = ({ open, onClose }) => {
  const optionsRef = useRef();

  const handleApplyFilters = () => {
    optionsRef.current?.applyFilters();
    onClose();
  };

  const handleResetFilters = () => {
    optionsRef.current?.resetFilters();
  }

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle>Filter Options</DialogTitle>
      <DialogContent>
        <FilterOptions ref={optionsRef} />
      </DialogContent>
      <DialogActions>
        <SoftButton onClick={handleResetFilters} variant="contained" color="primary">
          Reset
        </SoftButton>
        <SoftButton onClick={onClose} variant="outlined">
          Cancel
        </SoftButton>
        <SoftButton onClick={handleApplyFilters} variant="contained" color="primary">
          Apply
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
};

export default memo(FilterDialog);
